export const NOTIFICATION_EVENT = {
  LipSyncDone: 'project_lipsync_done',
} as const;

export type NotificationEventName = (typeof NOTIFICATION_EVENT)[keyof typeof NOTIFICATION_EVENT];

export type Notification = {
  event_name: NotificationEventName;
  project_id: string;
  read: boolean;
  space_id: string;
};

export type NotificationsResponse = Notification[];
